import { useState, useEffect, useRef } from 'react'
import { getCitiesByState, IBGEMunicipio } from 'sharedKernel/api/utils/ibge'

interface UseCitiesByStateResult {
  cities: IBGEMunicipio[]
  error: string | null
}

export const useCitiesByState = (stateUf: string): UseCitiesByStateResult => {
  const [cities, setCities] = useState<IBGEMunicipio[]>([])
  const [error, setError] = useState<string | null>(null)
  const cache = useRef<Record<string, IBGEMunicipio[]>>({})

  useEffect(() => {
    if (!stateUf) {
      setCities([])
      setError(null)
      return
    }

    if (cache.current[stateUf] != null) {
      setCities(cache.current[stateUf])
      setError(null)
      return
    }

    let cancelled = false

    setError(null)

    getCitiesByState(stateUf)
      .then((data) => {
        if (!cancelled) {
          cache.current[stateUf] = data
          setCities(data)
        }
      })
      .catch(() => {
        if (!cancelled) setError('Erro ao carregar cidades. Tente novamente.')
      })

    return () => {
      cancelled = true
    }
  }, [stateUf])

  return { cities, error }
}
